const hasBuffer = typeof Buffer !== 'undefined';
const textEncoder = typeof TextEncoder !== 'undefined' ? new TextEncoder() : null;
const textDecoder = typeof TextDecoder !== 'undefined' ? new TextDecoder() : null;

const encodeWithBrowser = (value: string) => {
  if (typeof window === 'undefined' || typeof window.btoa !== 'function' || !textEncoder) {
    throw new Error('Browser base64 encoding is unavailable');
  }
  const bytes = textEncoder.encode(value);
  let binary = '';
  bytes.forEach(byte => {
    binary += String.fromCharCode(byte);
  });
  return window.btoa(binary);
};

const decodeWithBrowser = (value: string) => {
  if (typeof window === 'undefined' || typeof window.atob !== 'function' || !textDecoder) {
    throw new Error('Browser base64 decoding is unavailable');
  }
  const binary = window.atob(value);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return textDecoder.decode(bytes);
};

export const encodeBase64 = (value: string): string => {
  if (hasBuffer) {
    return Buffer.from(value, 'utf-8').toString('base64');
  }
  return encodeWithBrowser(value);
};

export const decodeBase64 = (value: string): string => {
  if (hasBuffer) {
    return Buffer.from(value, 'base64').toString('utf-8');
  }
  return decodeWithBrowser(value);
};
